
// 订单列表分页
export function getOrderList(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/order/pageList',
    data
  })
}

// 新增保存订单
export function saveNewOrder(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/order/add',
    data
  })
}
// 编辑保存
export function saveEditOrder(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/order/edit',
    data
  })
}
// 更新订单（删除、启用、暂停，结束）
export function updateOrder(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/order/operate',
    data
  })
}
// 订单开关处启用暂停
export function operateOrder(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/order/operate',
    data
  }).then(data => {
    return data
  }).catch(e => {
    return {
      isError: true,
      errorMsg: e.message
    }
  })
}
export function scheduleOperate(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/schedule/operate',
    data
  })
}
// 更新订单名称
export function updateOrderName(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/order/edit',
    data
  })
}
// 更新投放计划
export function scheduleEdit(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/schedule/edit',
    data
  })
}
// 更新订单状态
export function updateOrderStatus(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/order/operate',
    data
  })
}
// 查询单条记录
export function getOrderById(params) {
  return this.fetch({
    method: 'get',
    url: 'api/dsp/order/dataOne',
    params
  })
}
// 获取可用订单
export function getAvailableOrder(params) {
  return this.fetch({
    method: 'get',
    url: 'api/dsp/order/getAvailableOrder',
    params
  })
}
// 结算信息
export function getSettleList(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/settlement/settleList',
    data
  })
}
// 结算明细
export function getSettleDetailList(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/settlement/settleDetailPageList',
    data
  })
}
// 合计结算明细总价
export function getSumSettleDetailPrice(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/settlement/sumSettleDetailPrice',
    data
  })
}
// 判断订单是否可以删除
export function selectCanDeleteOrderIds(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/order/selectCanDeleteOrderIds',
    data
  })
}
// 确认结算金额
export function confirmSettle(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/settlement/confirmSettle',
    data
  })
}

// 获取广告主对应价格策略
export function getPartnerSpacePrice(params) {
  return this.fetch({
    method: 'get',
    url: 'api/dsp/order/getPartnerSpacePrice',
    params
  })
}
// 溢价策略
export function getPartnerDirectPremium(params) {
  return this.fetch({
    method: 'get',
    url: 'api/dsp/order/getPartnerDirectPremium',
    params
  })
}
// 订单标签
export function getOrderTags(params) {
  return this.fetch({
    method: 'get',
    url: 'api/dsp/base/queryOrderTags',
    params
  })
}
//  获取指定类型的字典列表 主要获取订单标签
export function queryDictData(params) {
  return this.fetch({
    method: 'get',
    url: 'api/dsp/base/queryDictData',
    params
  })
}
// 获取使用中的广告位
export function getUesSpaceList() {
  return this.fetch({
    method: 'get',
    url: 'api/dsp/base/getUseSpaceList'
  })
}

// 获取订单下计划单时间边界
export function getOrderTime(params) {
  return this.fetch({
    method: 'get',
    url: 'api/dsp/order/getOrderTime',
    params
  })
}

// 获取订单客户品牌标签列表
export function getSuggestBrands(params) {
  return this.fetch({
    method: 'get',
    url: 'api/dsp/order/getCustomerBrandTags',
    params
  })
}

// 获取订单客户产品标签列表
export function getSuggestProducts(params) {
  return this.fetch({
    method: 'get',
    url: 'api/dsp/order/getCustomerProductTags',
    params
  })
}

export function checkPauseOrder(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/order/checkPauseOrder',
    data
  })
}

// 获取ERP订单列表
export function getErpOrderPageList(data) {
  return this.fetch({
    method: 'post',
    url: 'api/admin/subOrder/pageList',
    data
  })
}

// 获取ERP订单详情
export function getErpOrderDetail(data) {
  return this.fetch({
    method: 'post',
    url: 'api/admin/subOrder/data',
    data
  })
}
